export default __webpack_public_path__ + "static/media/fruit-768w.325f1042.webp";